import React from 'react';
import { createRoot } from 'react-dom/client';
import KMLMarkerEditor from './KMLMarkerEditor';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <KMLMarkerEditor />
  </React.StrictMode>
);
